import React from 'react'
import { BaseTable } from 'components/ui_components/table'
import { compose } from 'redux'
import { withNotificationCenter } from 'NotificationCenter';
import { tableColConfig } from 'config/resources/requisitionsResource';
import dataProvider, { GET_LIST } from 'providers/dataProvider';

class BillingBatchDetailsSubTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      loading: true,
      error: null,
      orderBy: 'reqId',
      order: 'asc'
    };
  }

  componentDidMount() {
    this.fetchBillingBatchDetails();
  }

  componentDidUpdate(prevProps) {
    // Refetch if parent row changes or filter changes
    if (prevProps.parentRow?.id !== this.props.parentRow?.id ||
        JSON.stringify(prevProps.filter) !== JSON.stringify(this.props.filter)) {
      this.fetchBillingBatchDetails();
    }
  }
  
  fetchBillingBatchDetails = async () => {
    const { parentRow, notificationCenter, filter } = this.props;
    
    if (!parentRow || !parentRow.id) return;
    
    try {
      this.setState({ loading: true });
      const filterParams = filter || {};
      
      const response = await dataProvider(
        GET_LIST,
        `billing/batch/details/${parentRow.id}`,
        { 
          pagination: { 
            page: 1, 
            perPage: -1 
          },
          filter: filterParams  // Pass filters to API for requisition-level filtering (reqId, patientFirstName, patientLastName, dateCollected)
        }
      );
      
      if (response && response.data) {
        this.setState({ 
          tableData: response.data,
          loading: false
        });
      } else {
        this.setState({ 
          tableData: [],
          loading: false,
          error: 'No details found for this billing batch' 
        });
        notificationCenter.show('No details found for this billing batch', 'warning');
      }
    } catch (error) {
      console.error('Error fetching billing batch details:', error);
      this.setState({ 
        loading: false,
        error: error.message,
        tableData: []
      });
      notificationCenter.show(
        `Error fetching billing batch details: ${error.message}`,
        'error'
      );
    }
  };

  // Helper function to convert the subTable configuration to BaseTable format
  getColumnsForBaseTable = () => {
    const subTableConfig = tableColConfig.groupsByHash.BillingBatch.subTable;
    const columnIds = subTableConfig.tableColById;
    const columnConfigs = subTableConfig.tableColByHash;
    
    // Get the columns with their configurations
    const columns = columnIds.map(id => ({
      id,
      ...columnConfigs[id]
    }));
    
    // Add linkAccessor to the reqId column for navigation to requisition details
    return columns.map(column => {
      if (column.id === 'reqId') {
        return {
          ...column,

        };
      }
      return column;
    });
  };

  render() {
    const { loading, tableData, error, orderBy, order } = this.state;
    const columns = this.getColumnsForBaseTable();

    // Get custom row actions from props if available
    const { customRowActions } = this.props;

    // Process the custom row actions to properly use the reqId from the row
    const processedCustomRowActions = customRowActions ? customRowActions.map(action => {
      return {
        ...action,
        // Replace the handleOnClick to use the correct ID from the row
        handleOnClick: (rows) => {
          if (this.props.actionHandlers && this.props.actionHandlers.handleBillingDetailsDownload) {
            // Directly use the reqId field from the row
            const row = rows[0];
            this.props.actionHandlers.handleBillingDetailsDownload(row.reqId);
          }
        }
      };
    }) : [];

    return (
      <div className="subtable-wrap">
        <div className="subtable-content" style={{ maxHeight: '400px', overflow: 'auto' }}>
          {loading ? (
            <div></div>
          ) : error ? (
            <div>Error: {error}</div>
          ) : tableData.length === 0 ? (
            <div>Empty Table</div>
          ) : (
            <>
              <BaseTable 
                rows={tableData}
                rowsPerPage={tableData.length}
                columns={columns}
                orderBy={orderBy}
                order={order}
                showToolbar={false}
                showSelect={false}
                showControls={true}
                collapsibleTable={false}
                customRowActions={processedCustomRowActions}
              />
            </>
          )}
        </div>
      </div>
    );
  }
}

export default compose(
  withNotificationCenter(),
)(BillingBatchDetailsSubTable)
